<template>
  <div class="home">
    <p>欢迎来到后台管理系统</p>
  </div>
</template>

<script>
// @ is an alias to /src


export default {
  name: 'Home',
  components: {

  },
  data(){
    return{

    }
  },
  methods:{

  },
  created() {
   
  },
}
</script>
